import ApiPermisos from "./../../services/apiPermisos";

export default {
  namespaced: true,
  state: {
    //user: null,
    user: JSON.parse((localStorage.getItem('user') && localStorage.getItem('user').includes('id')) ? localStorage.getItem('user') :  '{}'),
    onboarding: "",
    loadingOn: "",
    profile: "",
    errorMsj: "",
    userData: JSON.parse((localStorage.getItem('userData') && localStorage.getItem('userData').includes('id')) ? localStorage.getItem('userData') : '{}'),
    businessPartner: "",
    moduleSelect: ""
  },
  getters: {
    getUser: state => {
      return state.user;
    },
    getUsersCustomHome: state => {
      if (typeof state.user.custom_home_object !== "undefined") {
        return JSON.parse(state.user.custom_home_object);
      } else {
        return null;
      }
    }
  },
  mutations: {
    setUser: (state, user) => {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    setUserData: (state, userData) => {
      state.userData = userData;
      localStorage.setItem("userData", JSON.stringify(state.userData));
    },
    setOnboarding: (state, onboarding) => {
      state.onboarding = onboarding;
    },
    setLoadingOn: (state, loadingOn) => {
      state.loadingOn = loadingOn;
    },
    setProfile: (state, profile) => {
      state.profile = profile;
    },
    setBP: (state, user) => {
      state.businessPartner = user;
    },
    setModule: (state, module) => {
      state.moduleSelect = module;
    }
  },
  actions: {
    actUser: async ({ commit, state }) => {
      let response = await ApiPermisos.core_employee(state.user);
      if (response.error) {
        commit("setUserData", {});
      }
      commit("setUserData", response.data);
      return response.data;
    },

    actAuthLogin: async ({ commit }, data) => {
      commit("setLoadingOn", true); // Start loading
      let response = await ApiPermisos.identification_access(data);
      commit("setLoadingOn", false); // End loading
      //console.log("response: "+JSON.stringify(response));
      if (response.error) {
        return response.error;
      }
      commit("setUser", response.data.user);
      localStorage.setItem("token", response.data.api_token);
      return true;
    },

    //Trae la informacion del onboarding por rol
    actGetOnboarding: async ({ commit }) => {
      //console.log(data);
      commit("setLoadingOn", true); // Start loading
      let response = await ApiPermisos.getOnboarding();
      commit("setLoadingOn", false); // End loading
      if (response.error) {
        return response.error;
      } else {
        commit("setOnboarding", response);
      }
      return true;
    },

    // Trae informacion del perfil y firma
    actGetProfile: async ({ commit }, id) => {
      //console.log(data);
      let response = await ApiPermisos.getProfile(id);
      if (response.error) {
        return response.error;
      } else {
        commit("setProfile", response);
      }
      return true;
    },

    // Guarda informacion de la firma
    actSaveSignature: async ({ commit }, signature) => {
      let response = await ApiPermisos.saveSignature(signature);
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      }
      return response;
    },

    // Cambiar contraseña
    actPwdChange: async ({ commit }, data) => {
      let response = await ApiPermisos.savePwdChange(data);
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      }
      return response;
    },

    // Email recuperar contraseña
    actEmailRecovery: async ({ commit }, email) => {
      commit("setLoadingOn", true);
      let response = await ApiPermisos.emailRecovery(email);
      commit("setLoadingOn", false);
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      } else {
        return response;
      }
    },

    // Nueva contraseña
    actPwdNew: async ({ commit }, data) => {
      commit("setLoadingOn", true);
      let response = await ApiPermisos.savePwdNew(data);
      commit("setLoadingOn", false);
      //console.log("response: "+JSON.stringify(response));
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      }
      return response;
    },

    actSendMsjAdmin: async ({ commit }, data) => {
      commit("setLoadingOn", true);
      let response = await ApiPermisos.sendMsjAdmin(data);
      commit("setLoadingOn", false);
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      }
      return response;
    },

    actBP: async ({ commit, state }) => {
      let response = await ApiPermisos.core_employee_bp(state.userData);

      if (response.error) {
        commit("setBP", {});
      }
      commit("setBP", response.data);
      return response.data;
    },

    actModule: async ({ commit }, module) => {
      commit("setModule", module);
    },

    actUserLocalStorage: async ({ commit }) => {
      //let response = JSON.parse(localStorage.getItem("userData"));
      let response = "";
      try {
        response = JSON.parse(localStorage.getItem("userData"));
     
     } catch (err) {
    // 👇️ This runs
    console.log('Error: ', err.message);
  }
      commit("setUserData", response);
      return response;
    }
  }
};
